import { useT } from "@/i18n";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { monthName } from "@/components/common";

const ym = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

export function MonthInput({ value, onChange, className = "", max, ...rest }) {
  const { lang } = useT();
  const [y, m] = (value || ym(new Date())).split("-").map(Number);
  const maxYm = max === undefined ? ym(new Date()) : max;
  const shift = (n) => { const x = new Date(y, m - 1 + n, 1); const v = ym(x); if (maxYm && v > maxYm) return; onChange(v); };
  const label = `${monthName(m - 1, lang)} ${y}`;
  return <div className={`inline-flex items-center h-8 rounded-md border border-input bg-background text-sm shadow-sm ${className}`} data-testid={rest["data-testid"]}>
    <button type="button" className="px-1.5 text-muted-foreground hover:text-foreground" onClick={() => shift(-1)} aria-label="previous month" data-testid={rest["data-testid"] ? `${rest["data-testid"]}-prev` : undefined}><ChevronLeft className="h-4 w-4" /></button>
    <span className="px-1 min-w-[8rem] text-center capitalize" data-testid={rest["data-testid"] ? `${rest["data-testid"]}-label` : undefined}>{label}</span>
    <button type="button" className="px-1.5 text-muted-foreground hover:text-foreground" onClick={() => shift(1)} aria-label="next month" data-testid={rest["data-testid"] ? `${rest["data-testid"]}-next` : undefined}><ChevronRight className="h-4 w-4" /></button>
  </div>;
}
